/** Result comparison page — reads job IDs from URL query params (FR-CMP-03). */

import { useSearchParams, Link } from "react-router-dom";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import { useCompare } from "@/hooks/useCompare";
import ComparisonGrid from "@/components/ComparisonGrid";

export default function Compare() {
  const [searchParams] = useSearchParams();
  const idsParam = searchParams.get("ids") ?? "";
  const jobIds = idsParam.split(",").filter(Boolean);

  const { data, isLoading, isError } = useCompare(jobIds);

  if (jobIds.length < 2) {
    return (
      <Box>
        <Typography variant="h4" gutterBottom>Compare Results</Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          Select 2-4 jobs from the <Link to="/jobs">Jobs page</Link> to compare.
        </Alert>
      </Box>
    );
  }

  if (jobIds.length > 4) {
    return (
      <Box>
        <Typography variant="h4" gutterBottom>Compare Results</Typography>
        <Alert severity="warning">Maximum 4 jobs can be compared at once.</Alert>
      </Box>
    );
  }

  if (isLoading) return <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}><CircularProgress /></Box>;
  if (isError) return <Alert severity="error">Failed to load comparison data.</Alert>;

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Compare Results</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>Comparing {jobIds.length} jobs</Typography>
      {data && <ComparisonGrid items={data.results} />}
    </Box>
  );
}
